// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/MainMenu.css */

.main-menu {
	width: 250px; /* Width of the sidebar */
	height: 100vh; /* Full height */
	background-color: #2c3e50; /* Dark background */
	color: #ecf0f1; /* Light text */
	display: flex;
	flex-direction: column;
	position: fixed; /* Fixed Sidebar */
	top: 0;
	left: 0;
	box-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);
	transition: width 0.3s ease; /* Smooth transition if you ever want to collapse it */
	overflow-y: auto; /* Allow scrolling if content exceeds height */
  }
  
  .menu-header {
	padding: 20px 15px;
	text-align: center;
	border-bottom: 1px solid #34495e;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
  }
  
  .menu-logo-icon {
	  color: #1abc9c; /* Teal color for icon */
  }
  
  .menu-title {
	  font-size: 1.4em;
	  font-weight: bold;
	  white-space: nowrap; /* Prevent wrapping */
	  overflow: hidden; /* Hide overflow */
  }
  
  
  .main-menu ul {
	list-style: none;
	padding: 0;
	margin: 0;
	flex-grow: 1; /* Allows footer to stick to bottom */
	margin-top: 15px;
  }
  
  .main-menu li {
	margin: 0;
  }
  
  .menu-link {
	display: flex;
	align-items: center;
	padding: 15px 20px;
	color: #ecf0f1;
	text-decoration: none;
	transition: background-color 0.2s ease, color 0.2s ease;
	white-space: nowrap; /* Prevent text wrapping */
	overflow: hidden; /* Hide overflow */
	text-overflow: ellipsis; /* Add ellipsis if text is too long */
  }
  
  .menu-icon {
	margin-right: 15px;
	font-size: 1.5em; /* Icon size */
	min-width: 30px; /* Ensure alignment */
	text-align: center;
	display: inline-block;
  }
  
  .menu-text {
	font-size: 1.1em;
  }
  
  .menu-link:hover {
	background-color: #34495e; /* Slightly lighter background on hover */
	color: #ffffff;
  }
  
  /* Active link styling */
  .menu-link.active {
	background-color: #1abc9c; /* Teal background for active link */
	color: #ffffff;
	font-weight: bold;
	border-left: 5px solid #16a085; /* Darker teal accent */
	padding-left: 15px; /* Adjust padding for the border */
  }
  
  .menu-link.active .menu-icon {
	  /* Optional: style active icon differently */
  }
  
  .menu-footer {
	  padding: 15px;
	  text-align: center;
	  font-size: 0.8em;
	  color: #bdc3c7; /* Lighter grey */
	  border-top: 1px solid #34495e;
	  margin-top: auto; /* Pushes footer to bottom */
  }
  
  /* Simple scrollbar styling */
  .main-menu::-webkit-scrollbar {
	width: 6px;
  }
  .main-menu::-webkit-scrollbar-track {
	background: #2c3e50;
  }
  .main-menu::-webkit-scrollbar-thumb {
	background-color: #34495e;
	border-radius: 3px;
  }`, "",{"version":3,"sources":["webpack://./src/components/MainMenu.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;CACC,YAAY,EAAE,yBAAyB;CACvC,aAAa,EAAE,gBAAgB;CAC/B,yBAAyB,EAAE,oBAAoB;CAC/C,cAAc,EAAE,eAAe;CAC/B,aAAa;CACb,sBAAsB;CACtB,eAAe,EAAE,kBAAkB;CACnC,MAAM;CACN,OAAO;CACP,wCAAwC;CACxC,2BAA2B,EAAE,sDAAsD;CACnF,gBAAgB,EAAE,8CAA8C;EAC/D;;EAEA;CACD,kBAAkB;CAClB,kBAAkB;CAClB,gCAAgC;CAChC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,SAAS;EACR;;EAEA;GACC,cAAc,EAAE,wBAAwB;EACzC;;EAEA;GACC,gBAAgB;GAChB,iBAAiB;GACjB,mBAAmB,EAAE,qBAAqB;GAC1C,gBAAgB,EAAE,kBAAkB;EACrC;;;EAGA;CACD,gBAAgB;CAChB,UAAU;CACV,SAAS;CACT,YAAY,EAAE,qCAAqC;CACnD,gBAAgB;EACf;;EAEA;CACD,SAAS;EACR;;EAEA;CACD,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,uDAAuD;CACvD,mBAAmB,EAAE,0BAA0B;CAC/C,gBAAgB,EAAE,kBAAkB;CACpC,uBAAuB,EAAE,qCAAqC;EAC7D;;EAEA;CACD,kBAAkB;CAClB,gBAAgB,EAAE,cAAc;CAChC,eAAe,EAAE,qBAAqB;CACtC,kBAAkB;CAClB,qBAAqB;EACpB;;EAEA;CACD,gBAAgB;EACf;;EAEA;CACD,yBAAyB,EAAE,yCAAyC;CACpE,cAAc;EACb;;EAEA,wBAAwB;EACxB;CACD,yBAAyB,EAAE,oCAAoC;CAC/D,cAAc;CACd,iBAAiB;CACjB,8BAA8B,EAAE,uBAAuB;CACvD,kBAAkB,EAAE,kCAAkC;EACrD;;EAEA;GACC,4CAA4C;EAC7C;;EAEA;GACC,aAAa;GACb,kBAAkB;GAClB,gBAAgB;GAChB,cAAc,EAAE,iBAAiB;GACjC,6BAA6B;GAC7B,gBAAgB,EAAE,4BAA4B;EAC/C;;EAEA,6BAA6B;EAC7B;CACD,UAAU;EACT;EACA;CACD,mBAAmB;EAClB;EACA;CACD,yBAAyB;CACzB,kBAAkB;EACjB","sourcesContent":["/* src/components/MainMenu.css */\n\n.main-menu {\n\twidth: 250px; /* Width of the sidebar */\n\theight: 100vh; /* Full height */\n\tbackground-color: #2c3e50; /* Dark background */\n\tcolor: #ecf0f1; /* Light text */\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: fixed; /* Fixed Sidebar */\n\ttop: 0;\n\tleft: 0;\n\tbox-shadow: 2px 0 5px rgba(0, 0, 0, 0.2);\n\ttransition: width 0.3s ease; /* Smooth transition if you ever want to collapse it */\n\toverflow-y: auto; /* Allow scrolling if content exceeds height */\n  }\n  \n  .menu-header {\n\tpadding: 20px 15px;\n\ttext-align: center;\n\tborder-bottom: 1px solid #34495e;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 10px;\n  }\n  \n  .menu-logo-icon {\n\t  color: #1abc9c; /* Teal color for icon */\n  }\n  \n  .menu-title {\n\t  font-size: 1.4em;\n\t  font-weight: bold;\n\t  white-space: nowrap; /* Prevent wrapping */\n\t  overflow: hidden; /* Hide overflow */\n  }\n  \n  \n  .main-menu ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n\tflex-grow: 1; /* Allows footer to stick to bottom */\n\tmargin-top: 15px;\n  }\n  \n  .main-menu li {\n\tmargin: 0;\n  }\n  \n  .menu-link {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 15px 20px;\n\tcolor: #ecf0f1;\n\ttext-decoration: none;\n\ttransition: background-color 0.2s ease, color 0.2s ease;\n\twhite-space: nowrap; /* Prevent text wrapping */\n\toverflow: hidden; /* Hide overflow */\n\ttext-overflow: ellipsis; /* Add ellipsis if text is too long */\n  }\n  \n  .menu-icon {\n\tmargin-right: 15px;\n\tfont-size: 1.5em; /* Icon size */\n\tmin-width: 30px; /* Ensure alignment */\n\ttext-align: center;\n\tdisplay: inline-block;\n  }\n  \n  .menu-text {\n\tfont-size: 1.1em;\n  }\n  \n  .menu-link:hover {\n\tbackground-color: #34495e; /* Slightly lighter background on hover */\n\tcolor: #ffffff;\n  }\n  \n  /* Active link styling */\n  .menu-link.active {\n\tbackground-color: #1abc9c; /* Teal background for active link */\n\tcolor: #ffffff;\n\tfont-weight: bold;\n\tborder-left: 5px solid #16a085; /* Darker teal accent */\n\tpadding-left: 15px; /* Adjust padding for the border */\n  }\n  \n  .menu-link.active .menu-icon {\n\t  /* Optional: style active icon differently */\n  }\n  \n  .menu-footer {\n\t  padding: 15px;\n\t  text-align: center;\n\t  font-size: 0.8em;\n\t  color: #bdc3c7; /* Lighter grey */\n\t  border-top: 1px solid #34495e;\n\t  margin-top: auto; /* Pushes footer to bottom */\n  }\n  \n  /* Simple scrollbar styling */\n  .main-menu::-webkit-scrollbar {\n\twidth: 6px;\n  }\n  .main-menu::-webkit-scrollbar-track {\n\tbackground: #2c3e50;\n  }\n  .main-menu::-webkit-scrollbar-thumb {\n\tbackground-color: #34495e;\n\tborder-radius: 3px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
